/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface InstructionsDto
 */
export interface InstructionsDto {
    /**
     * 
     * @type {string}
     * @memberof InstructionsDto
     */
    readonly link: string;
    /**
     * 
     * @type {string}
     * @memberof InstructionsDto
     */
    readonly icon1: string;
    /**
     * 
     * @type {string}
     * @memberof InstructionsDto
     */
    readonly icon2: string;
    /**
     * 
     * @type {string}
     * @memberof InstructionsDto
     */
    $type?: InstructionsDtoTypeEnum;
}


/**
 * @export
 */
export const InstructionsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedSystemComponentDtoInstructionsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.SystemComponent.Dto.InstructionsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type InstructionsDtoTypeEnum = typeof InstructionsDtoTypeEnum[keyof typeof InstructionsDtoTypeEnum];



/**
 * Check if a given object implements the InstructionsDto interface.
 */
export function instanceOfInstructionsDto(value?: unknown): value is InstructionsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(InstructionsDtoTypeEnum)[0];
}

export function InstructionsDtoFromJSON(json: any): InstructionsDto {
    return InstructionsDtoFromJSONTyped(json, false);
}

export function InstructionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstructionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'link': json['link'],
        'icon1': json['icon1'],
        'icon2': json['icon2'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function InstructionsDtoToJSON(value?: Omit<InstructionsDto, 'link'|'icon1'|'icon2'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        '$type': value['$type'],
    });
}

